var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstudiante4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 94,
    viewBox: "0 0 57 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 73.57L19.72 62.94V32.56L1.6 43.19V73.57Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.39 44.29L1.6 44.98V73.57L0.39 72.98V44.29Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.58 71.04L39.54 61.18V41.91L22.58 51.77V71.04Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 54.5V51.7H22.58V53.62L39.65 63.48L56.61 53.62",
    fill: "#EAEAEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 54.5V51.7H22.58V53.62L39.65 63.48L56.61 53.62",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.65 82.75L56.61 72.89V53.62L39.65 63.48V82.75Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 51.7L39.54 41.84L22.58 51.7L39.65 61.56L56.61 51.7Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.92 39.72C51.9459 36.3108 51.6107 32.9085 50.92 29.57C50.04 25.15 49.11 22.88 39.4 19.23L39.46 19.36C38.3804 18.9623 37.2272 18.8046 36.0805 18.8979C34.9338 18.9911 33.8211 19.3331 32.82 19.9C31.7266 20.4427 30.8745 21.3732 30.43 22.51C29.53 24.51 30.09 28.19 30.77 33.23C28.1733 35.5855 25.2115 37.5038 22 38.91L25.18 40.91C27.0343 40.109 28.8089 39.1347 30.48 38C29.7655 40.2604 29.5606 42.651 29.88 45C19.41 50.55 18.07 54.32 20.75 73.28L24.47 75.35C25.47 65.29 25.6 61.49 29.84 57.79C28.54 62.64 28.97 68.89 29.84 78.26L33.56 80.33C37.56 64.27 37.9 62.33 42.86 58.72C43.7985 58.0498 44.6694 57.2896 45.46 56.45C47.46 54.23 48.41 49.34 48.25 47.45C50.07 45.12 51.92 42.18 51.92 39.72Z",
    fill: "#252525",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8 78.27C21.8 82.27 25.94 87.97 33.52 80.34L29.8 78.27Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8 14.24C36.3077 14.24 37.53 13.0177 37.53 11.51C37.53 10.0023 36.3077 8.78 34.8 8.78C33.2923 8.78 32.07 10.0023 32.07 11.51C32.07 13.0177 33.2923 14.24 34.8 14.24Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M47.57 50.38C46.45 58.38 50.96 55.52 50.21 50.72L47.57 50.38Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 53.34V50.78L0.39 42.53V44.29L33.18 63.16L51.3 52.54",
    fill: "#DEDEDE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 53.34V50.78L0.39 42.53V44.29L33.18 63.16L51.3 52.54",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.18 93.54L51.3 82.92V52.54L33.18 63.16V93.54Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 50.78L18.52 31.91L0.39 42.53L33.18 61.41L51.3 50.78Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.18 93.54L31.98 92.94V62.56L33.18 63.16V93.54Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.78 48.82L32.14 56.22L23.53 51.27L36.16 43.87L44.78 48.82Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.58 43.06L19.94 50.47L11.32 45.52L23.96 38.11L32.58 43.06Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 73.29C11.68 78.04 17.42 81.59 24.47 75.36L20.75 73.29Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.27 49.57C36.27 51.9 39.94 57.57 44.46 51.57L41.27 49.57Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.28 37.6C15.21 39.49 18.89 43.6 24.47 39.6L21.28 37.6Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33.15 17.83C33.0399 18.3588 33.045 18.9051 33.165 19.4318C33.285 19.9585 33.5171 20.4531 33.8454 20.882C34.1737 21.3109 34.5906 21.664 35.0677 21.9174C35.5447 22.1707 36.0708 22.3183 36.61 22.35C36.6753 22.6885 36.7621 23.0226 36.87 23.35C37.28 24.48 43.5 24.45 43.08 21.82C42.61 18.91 46.41 15.54 44.3 11.82C40.8 5.69 35.06 8.14001 33.91 13.18C33.5758 14.7157 33.3221 16.2678 33.15 17.83Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M36.06 11.47C38.9 10.85 39.8 11.42 39.8 15.2C39.8 15.2 41.8 16.88 41.8 14.84C42.16 7.17999 36.06 11.47 36.06 11.47Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M36.06 11.47C34.64 9.82 33.91 13.25 33.91 13.25C33.91 13.25 34.2 8 38.39 8C40.57 8 40.58 9.46 40.58 9.46L36.06 11.47Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M46.14 20.11C47.7582 20.11 49.07 18.7982 49.07 17.18C49.07 15.5618 47.7582 14.25 46.14 14.25C44.5218 14.25 43.21 15.5618 43.21 17.18C43.21 18.7982 44.5218 20.11 46.14 20.11Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M36.06 11.47C36.76 9.09 37.88 7.78 39.63 7.67C40.6466 7.61492 41.6605 7.81944 42.5763 8.2643C43.4921 8.70917 44.2796 9.37975 44.8647 10.2129C45.4498 11.0461 45.8133 12.0145 45.921 13.0269C46.0286 14.0393 45.8769 15.0624 45.48 16C44.01 19.89 41.76 16.91 41.76 16.91L39.83 9.72L36.06 11.47Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8 15.2C39.89 17.2 41.22 17.97 42.45 18.73C43.09 19.12 41.95 22.92 44.17 19.34C46.39 15.76 39.8 15.2 39.8 15.2Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M51.92 39.72C51.92 44.66 44.46 51.53 44.46 51.53L41.27 49.53C41.27 49.53 45.64 42.45 46.02 40.39C46.4 38.33 45 35 44.28 33.25",
    fill: "#252525"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M51.92 39.72C51.92 44.66 44.46 51.53 44.46 51.53L41.27 49.53C41.27 49.53 45.64 42.45 46.02 40.39C46.4 38.33 45 35 44.28 33.25",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M30.74 33.25C26 35.5 21.28 37.6 21.28 37.6L24.47 39.6C26.5558 39.5292 28.602 39.0108 30.47 38.08",
    fill: "#252525"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.74 33.25C26 35.5 21.28 37.6 21.28 37.6L24.47 39.6C26.5558 39.5292 28.6021 39.0108 30.47 38.08",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M32.07 26.24C31.93 28.75 29.01 31.31 31.58 34.88L30.48 38",
    fill: "#252525"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M32.07 26.24C31.93 28.75 29.01 31.31 31.58 34.88L30.48 38",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstudiante4);
export default __webpack_public_path__ + "static/media/Estudiante4.ea653e95af45de303a96c2591366483b.svg";
export { ForwardRef as ReactComponent };